module.exports = __webpack_public_path__ + "static/linkedin-fe58f255f46572b37a97dcb3a66de4cb.png";